import React from 'react';
import { defineMessage, useIntl } from 'react-intl';

import { useLocalFormattedDateTime, useSellerFormattedDateTime } from '../../../hooks/use-datetime-formats';

/**
 * @typedef {import('./date-time-display-types.d.ts').DateTimeDisplayComponent} DateTimeDisplayComponent
 */

const localTimeMessage = defineMessage({
  description: "Hover message displaying a time in the user's local time",
  defaultMessage: 'Your local time: {time}',
  id: 'PM4H++',
});

/**
 * @type {DateTimeDisplayComponent}
 */
export const DateTimeDisplay = ({ className = '', includeTimezone = false, utcTimestamp }) => {
  const intl = useIntl();
  const sellerDateTimeString = useSellerFormattedDateTime(utcTimestamp, includeTimezone);
  const localDateTimeString = useLocalFormattedDateTime(utcTimestamp);

  if (sellerDateTimeString === localDateTimeString) {
    return <div className={className}>{sellerDateTimeString}</div>;
  }
  return (
    <div
      className={className}
      title={intl.formatMessage(localTimeMessage, {
        time: localDateTimeString,
      })}
    >
      {sellerDateTimeString}
    </div>
  );
};
